import config from 'Config';
import appendLangParam from 'Lib/utils/appendLangParam';
import appendLangPrefix from 'Lib/utils/appendLangPrefix';

const tinderImage = `${config.siteUrl}/static/tinder.png`;

const {
  navMenuLinks: { facebook, instagram, tiktok, twitter, youtube },
} = config;
const socialMediaLinks = [
  instagram,
  tiktok,
  youtube,
  twitter,
  facebook,
  'https://en.wikipedia.org/wiki/Tinder_(app)',
  'https://www.linkedin.com/company/tinder-incorporated',
];

export const getStructuredDataForWeb = (lang: string) => ({
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'Tinder',
  browserRequirements: 'Requires JavaScript. Requires HTML5.',
  applicationCategory: 'Lifestyle',
  countriesSupported: Object.keys(config.supportedLanguages).toString(),
  url: appendLangParam(config.sharedUrl, lang),
  image: tinderImage,
  operatingSystem: 'any',
  sameAs: socialMediaLinks,
  inLanguage: Object.keys(config.supportedLanguages).map((key) => ({
    '@type': 'Language',
    name: config.supportedLanguages[key],
    alternateName: key,
    sameAs: appendLangPrefix(config.sharedUrl, key),
  })),
  softwareHelp: {
    '@type': 'CreativeWork',
    url: config.navMenuLinks.faq.home,
  },
});

export const structuredDataForOrganization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  legalName: 'Tinder Inc.',
  url: config.sharedUrl,
  parentOrganization: 'Match Group',
  name: 'Tinder',
  logo: tinderImage,
  sameAs: socialMediaLinks,
};

/**
 * get alternate links for intl
 * @param  {String} href
 * @param  {?boolean} useLangPrefix
 * @return {Array<Object>} alternate links
 */
export const getIntlAlternateLinks = (href: string, useLangPrefix: boolean = true) => {
  const appendFn = useLangPrefix ? appendLangPrefix : appendLangParam;

  const links = [
    {
      rel: 'alternate',
      hrefLang: 'x-default',
      href,
    },
  ];
  Object.keys(config.supportedLanguages).forEach((lang: string) =>
    links.push({
      rel: 'alternate',
      hrefLang: lang,
      href: appendFn(href, lang),
    })
  );
  return links;
};
